import "bootstrap-sass";

import UserTiming from "../shared/helpers/user-timing";

// from common.js
import autocompleteToggle from "../components/autocomplete/AutocompleteToggle.js";
import embedYoutube from "../components/video.js";
import initGeneralEnquiry from "../components/enquiries/general_enquiry";
import initNamedEnquiry from "../components/enquiries/named_enquiry";
import scrollspy from "../components/scrollspy/scrollspy.js";

import cookieConsent from "../controllers/CookieConsent.jsx";
import mountNewsletterForm from "../controllers/Newsletter.jsx";
import mountPopovers from "../controllers/Popover.jsx";

import notifier from "../shared/helpers/airbrake";
import ellipsis from "../shared/helpers/ellipsis";
import emarsys from "../shared/helpers/emarsys";
import { trackClick, trackGoal } from "../shared/helpers/gtm_tracking";

import "../shared/helpers/defer-picture";
import "../shared/helpers/responsive-bg";
import '../shared/gtm-script-loader';

import "./common.scss";
// end from common.js

import "../scripts/sections/blocks/autocomplete";

import "./home.scss";

const userTiming = new UserTiming({ src: "home" });

// from common.js
function handleClickTracking() {
  document.addEventListener("click", e => {
    const target = e.target.closest(".gtm-track-click");

    if (target) {
      const { goal, href } = target.dataset;

      trackClick(target);
      if (goal) {
        trackGoal(goal);
      }

      if (href) {
        window.location.href = href;
      }
    }
  });
}
// end from cmmon.js

function onDOMContentLoaded() {
  userTiming.start("onDOMContentLoaded");

  userTiming.start("common");
  // from common.js
  autocompleteToggle();
  initGeneralEnquiry();
  initNamedEnquiry();
  handleClickTracking();
  ellipsis();
  cookieConsent();
  embedYoutube();
  mountNewsletterForm();
  mountPopovers();
  scrollspy();

  // end from common.js
  userTiming.finish("common");

  userTiming.finish("onDOMContentLoaded");
}

document.addEventListener("DOMContentLoaded", onDOMContentLoaded);

// from common.js
window.addEventListener("error", error => {
  notifier.notify({ error });
});

emarsys(window.emarsysData);
// end from common.js

userTiming.finish();



// WEBPACK FOOTER //
// ./entry_points/home.js